




































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, setInteractionMode } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { usuarioService } from "@/service/usuario/UsuarioService";

setInteractionMode("passive");

@Component({
  components: {
    GsModalDialog,
  },
})
export default class RecuperarSenha extends Vue {
  $refs!: {
    recuperarSenhaObserver: InstanceType<typeof ValidationObserver>;
  };

  email = "";
  loading = false;

  /* MODAL */
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  recuperarSenha() {
    this.loading = true;
    usuarioService
      .solicitarResetSenha(this.email)
      .then(() => {
        this.openDialog(true);
      })
      .catch((err: any) => {
        console.error(err);
        this.openDialog(false);
      });
  }

  closeDialog() {
    this.showDialog = false;
    if (this.successDialog) {
      this.$router.replace({ name: "Login" });
    }
  }

  openDialog(success: boolean) {
    this.loading = false;
    this.successDialog = success;
    if (success) {
      this.dialogTitle = "Sucesso";
      this.dialogMessage =
        "Solicitação de recuperação de senha efetuado com sucesso";
    } else {
      this.dialogTitle = "Erro";
      this.dialogMessage = "Falha ao solicitar recuperação de senha";
    }
    this.showDialog = true;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
